<template>
  <HContainer>
    <template #content>
      <HSpecColumnList
        :redemption-type="redemptionType"
        :list-item="giftCodeDetails"
      />
    </template>
  </HContainer>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";

@Options({
  props: {
    redemptionType: { type: Number, required: true },
    giftCode: { type: Array, required: true }
  },
  components: {
    HContainer,
    HSpecColumnList
  }
})
export default class HBorderPanel extends Vue {
  redemptionType!: number;
  giftCode!: any[];

  get giftCodeDetails() {
    const { giftCode } = this;
    const label = "ギフトコード";
    const detail = giftCode;

    const resultGiftCodeArray = [
      {
        label,
        detail
      }
    ];

    return resultGiftCodeArray;
  }
}
</script>
